export namespace CONNECTION_TYPE {
  export enum URL {
    TESTNET_LISBON = "https://lisbon.net.solidwallet.io/api/v3",
    TESTNET_BERLIN = "https://berlin.net.solidwallet.io/api/v3",
    TESTNET_SEJONG = "https://sejong.net.solidwallet.io/api/v3",
    MAINNET = "https://ctz.solidwallet.io/api/v3",
  }

  export enum NETWORK_ID {
    TESTNET_LISBON = "2",
    TESTNET_BERLIN = "7",
    TESTNET_SEJONG = "83",
    MAINNET = "1",
  }
}
